import React, { Component } from "react";
import { useLocation, useParams } from "react-router-dom";
import auth from "../services/authService";
import ErrorRedirect from "./common/ErrorRedirect";
import UrlService from "../services/urlService";
import Config from "../config.json";

const ecpsExtTokenCreation_Key = Config.ecpsExtTokenCreation_Key;

class OtpLoginInner extends Component {
    state = {
        authenticated: 0,
        errors: {},
        status: undefined
    };

    componentDidMount() {
        const { location, match } = this.props;
        const hash = UrlService.getHashFromUrl(location.hash);
        // In new flow: d_token is the ID token
        const body = {
            accTk: hash.access_token,
            idToken: hash.id_token || hash.d_token,
            reserved: match && match.params ? match.params.str : undefined
        };

        auth.login(body)
            .then(() => {
                const date = Date.now();
                localStorage.setItem(ecpsExtTokenCreation_Key, JSON.stringify(date));
                this.setState({ authenticated: 1 });
            })
            .catch((ex) => {
                const status = ex && ex.response && ex.response.status
                    ? ex.response.status
                    : undefined;
                this.setState({ authenticated: -1, status });
            });
    }

    render() {
        const { authenticated, status } = this.state;

        if (authenticated === 1) {
            setTimeout(() => (window.location = "/"), 1000);
            return null;
        } else if (authenticated === 0) {
            return (
                <React.Fragment>
                    <div
                        className="content"
                        style={{ padding: "10px", backgroundColor: "#fff", width: "100%" }}
                    >
                        Authenticating ...
                    </div>
                </React.Fragment>
            );
        }

        // authenticated === -1
        return ErrorRedirect(status);
    }
}

// Small wrapper to adapt React Router v6 hooks to the old props shape
function OtpLogin() {
    const location = useLocation();
    const params = useParams();

    const match = { params };

    return <OtpLoginInner location={location} match={match} />;
}

export default OtpLogin;
